/**
 * SupplierJourneyErrors (AJIP-16.02.008 · WS16)
 * ---------------------------------------------------------------------
 * Typed error hierarchy for the Supplier Journey. Every failure inside
 * Supplier Journey code paths returns or throws one of these subclasses.
 * Raw `Error` throws inside Supplier Journey code are prohibited by
 * governance.
 */
import { JourneyError } from '../core/JourneyErrors';

class SupplierJourneyError extends JourneyError {}
class InvalidSupplierContextError extends SupplierJourneyError {}
class InvalidSupplierStageError extends SupplierJourneyError {}
class InvalidSupplierTransitionError extends SupplierJourneyError {}
class SupplierJourneyNotActiveError extends SupplierJourneyError {}
class SupplierInstanceIdentityError extends SupplierJourneyError {}
class SupplierOwnershipAuthorityError extends SupplierJourneyError {}
class BuyerSupplierBoundaryError extends SupplierJourneyError {}
class SupplierRFQQuoteBoundaryError extends SupplierJourneyError {}
class SupplierVerificationTrustBoundaryError extends SupplierJourneyError {}
class SupplierMatchOpportunityBoundaryError extends SupplierJourneyError {}

const SUPPLIER_JOURNEY_ERROR_TYPES = Object.freeze([
  'SupplierJourneyError',
  'InvalidSupplierContextError',
  'InvalidSupplierStageError',
  'InvalidSupplierTransitionError',
  'SupplierJourneyNotActiveError',
  'SupplierInstanceIdentityError',
  'SupplierOwnershipAuthorityError',
  'BuyerSupplierBoundaryError',
  'SupplierRFQQuoteBoundaryError',
  'SupplierVerificationTrustBoundaryError',
  'SupplierMatchOpportunityBoundaryError',
]);

export {
  SupplierJourneyError,
  InvalidSupplierContextError,
  InvalidSupplierStageError,
  InvalidSupplierTransitionError,
  SupplierJourneyNotActiveError,
  SupplierInstanceIdentityError,
  SupplierOwnershipAuthorityError,
  BuyerSupplierBoundaryError,
  SupplierRFQQuoteBoundaryError,
  SupplierVerificationTrustBoundaryError,
  SupplierMatchOpportunityBoundaryError,
  SUPPLIER_JOURNEY_ERROR_TYPES,
};
